import type {CopilotClientConfirmation} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import {CheckIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './ClientConfirmations.module.css'

interface ClientConfirmationsProps {
  clientConfirmations: CopilotClientConfirmation[]
  authorName: string
}

export function ClientConfirmations({authorName, clientConfirmations}: ClientConfirmationsProps) {
  const clientConfirmation = clientConfirmations?.[0]
  const confirmationState = clientConfirmation?.state
  authorName = clientConfirmation?.userLogin || authorName

  return (
    <div className={clsx('my-1', styles.container)}>
      <span className={styles.text}>
        <CheckIcon /> {authorName} {confirmationState} the action
      </span>
    </div>
  )
}
